import moment from 'moment';
import months from 'constants/months';

const prevMonth = moment().subtract(1, 'months');

export const lastYear = prevMonth.year();
export const lastMonth = months[prevMonth.month()];
